import Datepicker from 'vanillajs-datepicker/Datepicker';
import nl from 'vanillajs-datepicker/locales/nl';
Object.assign(Datepicker.locales, nl);

document.addEventListener('DOMContentLoaded', () => {
    const $datepickers = document.querySelectorAll('.umbraco-forms-field input.date-picker');

    if ($datepickers.length) {
        let datepickerInstance = [];

        var options = {
            autohide: true,
            language: 'nl',
            format: 'dd-mm-yyyy',
            nextArrow: '<i class="las la-angle-right"></i>',
            prevArrow: '<i class="las la-angle-left"></i>',
            orientation: 'bottom'
        }

        $datepickers.forEach(($datepicker, i) => {
            datepickerInstance[i] = new Datepicker($datepicker, options);

            if ($datepicker.hasAttribute('data-umb')) {
                let $hiddenDatepicker = document.getElementById($datepicker.id.replace('_1', ''));
                if ($hiddenDatepicker.value) {
                    let date = new Date($hiddenDatepicker.value);
                    datepickerInstance[i].setDate(date);
                }

                $datepicker.addEventListener('changeDate', (event) => {
                    let date = new Date(new Date(event.detail.date).setHours(12, 0, 0, 0));
                    document.getElementById(event.target.id.replace('_1', '')).value = date.toISOString();
                });
            }
        });
    }
});
